import React, { Component } from "react";
import styles from "./index.module.scss";

import { darkmodeListener } from "../../theme";

import makeEndpoint from "../../endpoints";

import Button from "../../components/Button";
import Card from "../../components/Card";
import Loading from "../../components/Loading";
import Renderer from "../../components/Renderer";

import icon from "../../components/Login/assets/icon.svg";

import {
  AppConfig,
  UserSession,
  showConnect,
  openContractCall,
} from "@stacks/connect";

import {
  uintCV,
  intCV,
  bufferCV,
  stringAsciiCV,
  stringUtf8CV,
  standardPrincipalCV,
  trueCV,
  makeStandardFungiblePostCondition,
  FungibleConditionCode,
  createAssetInfo,
  makeStandardNonFungiblePostCondition,
  NonFungibleConditionCode,
  makeStandardSTXPostCondition,
  makeContractSTXPostCondition,
  callReadOnlyFunction,
  cvToJSON,
} from "@stacks/transactions";

import BigNum from "bn.js";

import InfiniteScroll from "react-infinite-scroll-component";

import { renderer } from "../../utils";
import { isMainnet, network } from "../../utils/SelfServe/contracts";
import Modal from "../../components/Modal";
import Confirm from "../../components/Confirm";

const appConfig = new AppConfig(["store_write", "publish_data"]);
const userSession = new UserSession({ appConfig });

type MonkeysLabsProps = {
  name: string;
};

type MonkeysLabsState = {
  name: string;
  contractAddress: string;
  contractName: string;
  description: string;
  image: string;
  total: number;
  lastTokenID: number;
  prices: number;
  currency?: string;
  saleData: Record<string, any>;
  sale: Array<any>;
  active: boolean;
  paused: boolean;
  userData?: any;
  offset: number;
  currencySelected: string;
  numberSelected: number;
  bmBalance: number;
  partnerBalance: number;
  bmSaleActive: boolean;
  partnerSaleActive: boolean;
  saleActive: boolean;
  modal?: any;
  nftContractName: string;
};

const fetchSize = 25;
class MonkeysLabs extends Component<MonkeysLabsProps, MonkeysLabsState> {
  state = {
    name: "",
    contractAddress: "",
    contractName: "",
    description: "",
    image: "",
    total: 0,
    saleData: {},
    sale: [],
    lastTokenID: 0,
    prices: 0,
    currency: undefined,
    active: false,
    paused: false,
    userData: undefined,
    offset: 1,
    numberSelected: 1,
    currencySelected: "STX",
    bmBalance: 0,
    partnerBalance: 0,
    bmSaleActive: false,
    partnerSaleActive: false,
    saleActive: false,
    modal: undefined,
    nftContractName: "",
  };

  componentDidMount() {
    try {
      const userData = localStorage.getItem("userData");
      if (userData) {
        this.setState({
          userData: JSON.parse(userData),
        });
        console.log(userData);
      }
    } catch {}

    darkmodeListener(styles["theme-light"], styles["theme-dark"]);

    fetch(makeEndpoint("/api/drop?name=" + this.props.name))
      .then((res) => {
        return res.json();
      })
      .then((artistData) => {
        console.log(artistData);

        if (artistData.active) {
          this.getBMBalance(
            artistData.contractAddress,
            artistData.contractName
          );

          this.getPartnerBalance(
            artistData.contractAddress,
            artistData.contractName
          );

          this.getSaleStatus(
            artistData.contractAddress,
            artistData.contractName
          );
        }

        this.setState(
          {
            name: artistData.name,
            contractAddress: artistData.contractAddress,
            contractName: artistData.contractName,
            description: artistData.description,
            image: artistData.image,
            total: artistData.total,
            prices: artistData.prices,
            active: artistData.active,
            paused: artistData.paused,
            currency: artistData.currency,
            nftContractName: artistData.nftContractName,
          },
          () => {
            fetch(
              makeEndpoint(
                "/api/nft/lastTokenID?address=" +
                  artistData.contractAddress +
                  "&name=" +
                  artistData.nftContractName +
                  "&reload=true"
              )
            );
            fetch(
              makeEndpoint(
                "/api/nft/lastTokenID?address=" +
                  artistData.contractAddress +
                  "&name=" +
                  artistData.nftContractName
              )
            )
              .then((res) => {
                return res.text();
              })
              .then((lastTokenStr) => {
                let lastToken = parseInt(lastTokenStr, 10);

                if (lastToken > 3500) {
                  lastToken = 3500;
                }

                this.setState(
                  {
                    lastTokenID: lastToken,
                  },
                  () => {
                    this.fetchNFTs();
                  }
                );
              });
          }
        );
      });
  }

  fetchNFTs() {
    var nfts: Array<any> = [];
    var numNFTs = Math.min(this.state.lastTokenID, fetchSize);
    if (this.state.lastTokenID < this.state.offset + numNFTs) {
      const diff = this.state.offset + numNFTs - this.state.lastTokenID;
      numNFTs -= diff;
    }

    for (var x = this.state.offset; x <= this.state.offset + numNFTs; x++) {
      nfts.push({
        contractAddress: this.state.contractAddress,
        tokenID: x,
        contractName: this.state.nftContractName,
        sold: true,
      });
    }

    var sale: Array<any> = this.state.sale;
    const filtered_nfts = nfts.filter((r: any) => {
      let filtered_list = sale.filter(
        (l: any) =>
          l.contractAddress == r.contractAddress &&
          l.contractName == r.contractName &&
          String(l.tokenID) == String(r.tokenID)
      );
      return filtered_list.length == 0;
    });

    sale.push(...filtered_nfts);
    this.setState(
      {
        sale: sale,
      },
      () => {
        this.fetchData(nfts);
      }
    );
  }

  getLength() {
    return this.state.sale.length;
  }

  fetchData(nfts: any) {
    for (var nft of nfts) {
      var params = "";
      params += "address=" + nft.contractAddress;
      params += "&name=" + nft.contractName;
      params += "&id=" + nft.tokenID;
      const nftId =
        nft.contractAddress + "." + nft.contractName + ":" + nft.tokenID;
      var saleDataRecord: any = this.state.saleData;
      if (saleDataRecord[nftId]) {
        continue;
      }
      fetch(makeEndpoint("/api/nft?" + params))
        .then((res) => res.json())
        .then((nftData) => {
          if (nftData.name) {
            var saleData = saleDataRecord;
            saleData[nftId] = nftData;
            this.setState({ saleData });
          }
        });
    }
  }

  getTotal() {
    return this.state.total;
  }

  getAvailable() {
    return this.getTotal() - this.state.lastTokenID;
  }

  getVolumeSold() {
    return this.state.lastTokenID * this.getFloorPrice();
  }

  getFloorPrice() {
    if (!this.state.currency) {
      return this.state.prices / 1e6;
    } else {
      return this.state.prices;
    }
  }

  nFormatter(num: number, digits: number) {
    const lookup = [
      { value: 1, symbol: "" },
      { value: 1e3, symbol: "K" },
      { value: 1e6, symbol: "M" },
      { value: 1e9, symbol: "B" },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup
      .slice()
      .reverse()
      .find(function (item) {
        return num >= item.value;
      });
    return item
      ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol
      : "0";
  }

  renderCard() {
    return this.state.sale.map((x: any) => {
      const saleData: any = this.state.saleData;
      const fullData: any =
        saleData[x.contractAddress + "." + x.contractName + ":" + x.tokenID];
      if (fullData) {
        return (
          <Card
            renderer={renderer(fullData)}
            collection={fullData.collection || fullData.name}
            name={fullData.name}
            currency={this.state.currency}
            sold={this.state.prices}
          />
        );
      } else if (x.contractName) {
        const titled =
          x.contractName[0].toUpperCase() + x.contractName.substring(1);
        return (
          <Card
            collection={titled}
            renderer={<Renderer />}
            currency={this.state.currency}
            name={titled + " #" + x.tokenID}
          />
        );
      }
    });
  }

  amount(): number {
    switch (this.state.currencySelected) {
      case "STX":
        return 45000000 * this.state.numberSelected;
      case "MIA":
        return 4000 * this.state.numberSelected;
      case "NYC":
        return 3000 * this.state.numberSelected;
    }
    return 45000000 * this.state.numberSelected;
  }

  fiveAmount() {
    return this.state.prices * 5;
  }

  tenAmount() {
    return this.state.prices * 10;
  }

  mintText() {
    let mintText;
    if (this.state.active && this.state.paused) {
      mintText = "MINTING CLOSED";
    } else if (!this.state.active) {
      mintText = "COMING SOON";
    } else if (this.state.lastTokenID >= this.state.total) {
      mintText = "VISIT MARKETPLACE";
    } else if (
      !this.state.bmSaleActive &&
      !this.state.partnerSaleActive &&
      !this.state.saleActive
    ) {
      mintText = "COMING SOON";
    } else if (this.state.bmBalance == 0 && this.state.bmSaleActive) {
      mintText = "BM MINTPASS ONLY";
    } else if (this.state.partnerBalance == 0 && this.state.partnerSaleActive) {
      mintText = "PARTNER MINTPASS ONLY";
    } else if (this.state.userData) {
      mintText = "MINT " + this.state.numberSelected;
    } else {
      mintText = "CONNECT WALLET TO MINT";
    }
    return mintText;
  }

  renderPrice() {
    if (!this.state.active && this.state.userData) {
      return false;
    }

    if (this.state.paused && this.state.userData) {
      return false;
    }

    if (this.state.lastTokenID >= this.state.total && this.state.userData) {
      return false;
    }

    if (
      !this.state.bmSaleActive &&
      !this.state.partnerSaleActive &&
      !this.state.saleActive
    ) {
      return false;
    }

    if (this.state.bmBalance == 0 && this.state.bmSaleActive) {
      return false;
    }

    if (this.state.partnerBalance == 0 && this.state.partnerSaleActive) {
      return false;
    }

    return true;

    // return (
    //   !(
    //     (this.state.active && this.state.paused) ||
    //     !this.state.active ||
    //     this.state.lastTokenID >= this.state.total
    //   ) && this.state.userData
    // );
  }

  stxAddress() {
    if (this.state.userData) {
      const userData: any = this.state.userData;
      if (isMainnet) {
        return userData.profile.stxAddress.mainnet;
      } else {
        return userData.profile.stxAddress.testnet;
      }
    } else {
      return null;
    }
  }

  authenticate() {
    showConnect({
      appDetails: {
        name: "Stacks NFT",
        icon: icon,
      },
      redirectTo: "/",
      onFinish: () => {
        let userData = userSession.loadUserData();
        this.setState({ userData: userData });
        localStorage.setItem("userData", JSON.stringify(userData));
        window.location.reload();
      },
      userSession: userSession,
    });
  }

  async getBMBalance(contractAddress: string, contractName: string) {
    const functionArgs: any[] = [standardPrincipalCV(this.stxAddress())];
    const senderAddress = contractAddress; // random address
    const options = {
      contractAddress,
      contractName,
      functionName: "get-bitcoin-monkeys-presale-balance",
      functionArgs: functionArgs,
      network,
      senderAddress,
    };

    const result = await callReadOnlyFunction(options);
    const balance = cvToJSON(result).value;

    this.setState({ bmBalance: balance });
  }

  async getPartnerBalance(contractAddress: string, contractName: string) {
    const functionArgs: any[] = [standardPrincipalCV(this.stxAddress())];
    const senderAddress = contractAddress; // random address
    const options = {
      contractAddress,
      contractName,
      functionName: "get-partner-presale-balance",
      functionArgs: functionArgs,
      network,
      senderAddress,
    };

    const result = await callReadOnlyFunction(options);
    const balance = cvToJSON(result).value;

    this.setState({ partnerBalance: balance });
  }

  async getSaleStatus(contractAddress: string, contractName: string) {
    const functionArgs: any[] = [];
    const senderAddress = contractAddress; // random address
    const options = {
      contractAddress,
      contractName,
      functionName: "get-sale-status",
      functionArgs: functionArgs,
      network,
      senderAddress,
    };

    const result = await callReadOnlyFunction(options);
    const status = cvToJSON(result).value;

    console.log(status);

    if (status && status.length > 0) {
      this.setState({
        bmSaleActive: status[0]["value"],
        partnerSaleActive: status[1]["value"],
        saleActive: status[2]["value"],
        // saleActive: true,
      });
    }
  }

  claim(
    contractAddress: string,
    contractName: string,
    salePrice: number,
    claimNumber: number
  ) {
    const functionArgs: any[] = [];

    let currencyString = "";
    switch (this.state.currencySelected) {
      case "NYC":
        currencyString = "-nyc";
        break;
      case "MIA":
        currencyString = "-mia";
        break;
    }

    let functionName;
    switch (claimNumber) {
      case 1:
        functionName = "claim" + currencyString;
        break;
      case 2:
        functionName = "claim" + currencyString + "-two";
        break;
      case 3:
        functionName = "claim" + currencyString + "-three";
        break;
      case 4:
        functionName = "claim" + currencyString + "-four";
        break;
      case 5:
        functionName = "claim" + currencyString + "-five";
        break;
      case 6:
        functionName = "claim" + currencyString + "-six";
        break;
      case 7:
        functionName = "claim" + currencyString + "-seven";
        break;
      case 8:
        functionName = "claim" + currencyString + "-eight";
        break;
      case 9:
        functionName = "claim" + currencyString + "-nine";
        break;
      case 10:
        functionName = "claim" + currencyString + "-ten";
        break;
    }

    let standardFungiblePostCondition;
    // let contractFungiblePostCondition;
    if (this.state.currencySelected == "STX") {
      // standardFungiblePostCondition = makeStandardSTXPostCondition(
      //   this.stxAddress(),
      //   FungibleConditionCode.LessEqual,
      //   new BigNum(this.amount())
      // );
      // contractFungiblePostCondition = makeContractSTXPostCondition(
      //   contractAddress,
      //   contractName,
      //   FungibleConditionCode.LessEqual,
      //   new BigNum(this.amount())
      // );
      standardFungiblePostCondition = makeStandardSTXPostCondition(
        this.stxAddress(),
        FungibleConditionCode.LessEqual,
        new BigNum(this.amount())
      );
    }

    const options: any = {
      contractAddress: contractAddress,
      contractName: contractName,
      functionName: functionName,
      network: network,
      functionArgs,
      postConditions: [standardFungiblePostCondition],
      // this.state.currencySelected == "STX"
      //   ? [standardFungiblePostCondition, contractFungiblePostCondition]
      //   : [standardFungiblePostCondition],
      appDetails: {
        name: "Stacks NFT",
        icon: icon,
      },
      onFinish: (data: any) => {
        this.setState({
          modal: {
            success: true,
            successTransaction: data.txId,
          },
        });
      },
      onCancel: () => {
        this.setState({
          modal: {
            success: false,
            errorMessage: "Transaction Cancelled",
          },
        });
      },
    };

    openContractCall(options);
  }

  openClaim(
    contractAddress: string,
    contractName: string,
    salePrice: number,
    tokenID: number
  ) {
    if (this.state.userData) {
      this.claim(contractAddress, contractName, salePrice, tokenID);
    } else {
      this.authenticate();
    }
  }

  mintingBehavior(claimNumber: number) {
    if (this.state.contractAddress && this.state.contractName) {
      if (!this.state.active || this.state.paused) {
        // no op
      } else if (this.state.lastTokenID >= this.state.total) {
        window.location.href =
          "https://stxnft.com/collections/bitcoin-monkeys-labs";
      } else {
        this.openClaim(
          this.state.contractAddress,
          this.state.contractName,
          this.state.prices,
          claimNumber
        );
      }
    }
  }

  mintButton() {
    if (this.amount() >= 0 && this.renderPrice()) {
      return (
        <div className={styles.MintButton}>
          <Button
            text={this.mintText()}
            price={this.amount()}
            currency={this.state.currencySelected}
            onClick={this.mintingBehavior.bind(
              this,
              this.state.numberSelected,
              this.state.currencySelected
            )}
          />
        </div>
      );
    } else if (this.state.lastTokenID >= this.state.total) {
      return (
        <div className={styles.MintButton}>
          <Button
            text={this.mintText()}
            onClick={this.mintingBehavior.bind(this)}
          />
        </div>
      );
    } else {
      return (
        <div className={styles.MintButton}>
          <Button text={this.mintText()} />
        </div>
      );
    }
  }

  nextBlocks(offset: number) {
    this.setState(
      {
        offset: offset,
      },
      () => {
        this.fetchNFTs();
      }
    );
  }

  setModal(modal: any) {
    this.setState({
      modal: modal,
    });
  }

  modalClose() {
    this.setState({
      modal: undefined,
    });
  }

  getBlocksNext() {
    this.nextBlocks(this.getLength());
  }

  hasMore() {
    return this.state.lastTokenID > this.state.offset;
  }

  render() {
    return (
      <div className={styles.Collections}>
        <div className={styles.MintTopBar}>
          <div className={styles.MintImageBorder}>
            <div className={styles.MintImage}>
              <img
                src={this.state.image}
                height={122}
                width={122}
                className={styles.MintImageSrc}
              />
            </div>
          </div>
        </div>
        {this.state.modal && (
          <Modal onClose={this.modalClose.bind(this)}>
            <Confirm
              success={this.state.modal["success"]}
              transactionId={this.state.modal["successTransaction"]}
              errorMessage={this.state.modal["errorMessage"]}
              onClose={this.modalClose.bind(this)}
            />
          </Modal>
        )}
        <div className={styles.MintContent}>
          <div className={styles.MintTitle}>{this.state.name}</div>
          <div
            className={styles.MintSummary}
            dangerouslySetInnerHTML={{ __html: this.state.description }}
          ></div>
          {this.state.active && this.state.lastTokenID < this.state.total && (
            <div className={styles.MintpassBalanceContainer}>
              <div className={styles.MintpassBalance}>
                Your Bitcoin Monkeys mintpass balance is {this.state.bmBalance}
              </div>
              <div className={styles.MintpassBalance}>
                Your partner mintpass balance is {this.state.partnerBalance}
              </div>
            </div>
          )}
          {this.state.active &&
          ((this.state.bmSaleActive && this.state.bmBalance > 0) ||
            (this.state.partnerSaleActive && this.state.partnerBalance > 0) ||
            this.state.saleActive) &&
          !this.state.paused &&
          this.state.lastTokenID < this.state.total &&
          this.state.userData ? (
            <div>
              <div style={{ display: "flex", justifyContent: "center" }}></div>
              <div style={{ display: "flex" }}>
                <div style={{ margin: "10px" }}>
                  <Button
                    text="1"
                    style={
                      this.state.numberSelected == 1 ? "PRIMARY" : "SECONDARY"
                    }
                    onClick={function (this: MonkeysLabs) {
                      this.setState({ numberSelected: 1 });
                    }.bind(this)}
                  />
                </div>
                <div style={{ margin: "10px" }}>
                  <Button
                    text="2"
                    style={
                      this.state.numberSelected == 2 ? "PRIMARY" : "SECONDARY"
                    }
                    onClick={function (this: MonkeysLabs) {
                      this.setState({ numberSelected: 2 });
                    }.bind(this)}
                  />
                </div>
                <div style={{ margin: "10px" }}>
                  <Button
                    text="3"
                    style={
                      this.state.numberSelected == 3 ? "PRIMARY" : "SECONDARY"
                    }
                    onClick={function (this: MonkeysLabs) {
                      this.setState({ numberSelected: 3 });
                    }.bind(this)}
                  />
                </div>
                <div style={{ margin: "10px" }}>
                  <Button
                    text="4"
                    style={
                      this.state.numberSelected == 4 ? "PRIMARY" : "SECONDARY"
                    }
                    onClick={function (this: MonkeysLabs) {
                      this.setState({ numberSelected: 4 });
                    }.bind(this)}
                  />
                </div>
                <div style={{ margin: "10px" }}>
                  <Button
                    text="5"
                    style={
                      this.state.numberSelected == 5 ? "PRIMARY" : "SECONDARY"
                    }
                    onClick={function (this: MonkeysLabs) {
                      this.setState({ numberSelected: 5 });
                    }.bind(this)}
                  />
                </div>
                <div style={{ margin: "10px" }}>
                  <Button
                    text="6"
                    style={
                      this.state.numberSelected == 6 ? "PRIMARY" : "SECONDARY"
                    }
                    onClick={function (this: MonkeysLabs) {
                      this.setState({ numberSelected: 6 });
                    }.bind(this)}
                  />
                </div>
                <div style={{ margin: "10px" }}>
                  <Button
                    text="7"
                    style={
                      this.state.numberSelected == 7 ? "PRIMARY" : "SECONDARY"
                    }
                    onClick={function (this: MonkeysLabs) {
                      this.setState({ numberSelected: 7 });
                    }.bind(this)}
                  />
                </div>
                <div style={{ margin: "10px" }}>
                  <Button
                    text="8"
                    style={
                      this.state.numberSelected == 8 ? "PRIMARY" : "SECONDARY"
                    }
                    onClick={function (this: MonkeysLabs) {
                      this.setState({ numberSelected: 8 });
                    }.bind(this)}
                  />
                </div>
                <div style={{ margin: "10px" }}>
                  <Button
                    text="9"
                    style={
                      this.state.numberSelected == 9 ? "PRIMARY" : "SECONDARY"
                    }
                    onClick={function (this: MonkeysLabs) {
                      this.setState({ numberSelected: 9 });
                    }.bind(this)}
                  />
                </div>
                <div style={{ margin: "10px" }}>
                  <Button
                    text="10"
                    style={
                      this.state.numberSelected == 10 ? "PRIMARY" : "SECONDARY"
                    }
                    onClick={function (this: MonkeysLabs) {
                      this.setState({ numberSelected: 10 });
                    }.bind(this)}
                  />
                </div>
              </div>
              <div style={{ margin: "10px" }}></div>
            </div>
          ) : (
            ""
          )}
          {this.mintButton()}
          <div className={styles.MintPrice}>
            <div className={styles.MintPriceContainer}>
              <div>{this.getTotal().toLocaleString("us")}</div>
              <div className={styles.MintPriceTitle}>TOTAL</div>
            </div>
            <div className={styles.MintPriceContainer}>
              <div>{this.getAvailable().toLocaleString("us")}</div>
              <div className={styles.MintPriceTitle}>REMAINING</div>
            </div>
            <div className={styles.MintPriceContainer}>
              <div className={styles.MintPriceIconContainer}>
                {!this.state.currency && (
                  <div className={styles.MintPriceIcon}>
                    <svg
                      width={"15px"}
                      height={"18px"}
                      viewBox={"0 0 15 18"}
                      version={"1.1"}
                      xmlns={"http://www.w3.org/2000/svg"}
                    >
                      <g
                        stroke={"none"}
                        stroke-width={"1"}
                        fill={"none"}
                        fill-rule={"evenodd"}
                      >
                        <g
                          transform={"translate(-889.000000, -497.000000)"}
                          stroke={"#707071"}
                        >
                          <g transform={"translate(528.000000, 492.000000)"}>
                            <g transform={"translate(361.000000, 6.000000)"}>
                              <g>
                                <line
                                  x1={"3.84615385"}
                                  y1={"6.58823529"}
                                  x2={"13.0769231"}
                                  y2={"6.58823529"}
                                ></line>
                                <line
                                  x1={"-9.60769925e-17"}
                                  y1={"6.17647059"}
                                  x2={"6.15384615"}
                                  y2={"6.17647059"}
                                  stroke-width={"2"}
                                ></line>
                                <line
                                  x1={"1.53846154"}
                                  y1={"6.17647059"}
                                  x2={"6.15384615"}
                                  y2={"6.17647059"}
                                  stroke-width={"2"}
                                  stroke-linecap={"round"}
                                ></line>
                                <line
                                  x1={"8.46153846"}
                                  y1={"6.17647059"}
                                  x2={"13.0769231"}
                                  y2={"6.17647059"}
                                  stroke-width={"2"}
                                  stroke-linecap={"round"}
                                ></line>
                                <line
                                  x1={"8.46153846"}
                                  y1={"6.17647059"}
                                  x2={"14.6153846"}
                                  y2={"6.17647059"}
                                  stroke-width={"2"}
                                ></line>
                                <line
                                  x1={"2.30769231"}
                                  y1={"0.411764706"}
                                  x2={"6.15384615"}
                                  y2={"6.17647059"}
                                  stroke-width={"2"}
                                  stroke-linejoin={"round"}
                                ></line>
                                <line
                                  x1={"8.46153846"}
                                  y1={"0.411764706"}
                                  x2={"12.3076923"}
                                  y2={"6.17647059"}
                                  stroke-width={"2"}
                                  stroke-linejoin={"round"}
                                  transform={
                                    "translate(10.384615, 3.294118) scale(-1, 1) translate(-10.384615, -3.294118) "
                                  }
                                ></line>
                              </g>
                              <g
                                transform={
                                  "translate(7.500000, 12.500000) scale(1, -1) translate(-7.500000, -12.500000) translate(0.000000, 9.000000)"
                                }
                              >
                                <line
                                  x1={"3.84615385"}
                                  y1={"6.58823529"}
                                  x2={"13.0769231"}
                                  y2={"6.58823529"}
                                ></line>
                                <line
                                  x1={"-9.60769925e-17"}
                                  y1={"6.17647059"}
                                  x2={"6.15384615"}
                                  y2={"6.17647059"}
                                  stroke-width={"2"}
                                ></line>
                                <line
                                  x1={"1.53846154"}
                                  y1={"6.17647059"}
                                  x2={"6.15384615"}
                                  y2={"6.17647059"}
                                  stroke-width={"2"}
                                  stroke-linecap={"round"}
                                ></line>
                                <line
                                  x1={"8.46153846"}
                                  y1={"6.17647059"}
                                  x2={"13.0769231"}
                                  y2={"6.17647059"}
                                  stroke-width={"2"}
                                  stroke-linecap={"round"}
                                ></line>
                                <line
                                  x1={"8.46153846"}
                                  y1={"6.17647059"}
                                  x2={"14.6153846"}
                                  y2={"6.17647059"}
                                  stroke-width={"2"}
                                ></line>
                                <line
                                  x1={"2.30769231"}
                                  y1={"0.411764706"}
                                  x2={"6.15384615"}
                                  y2={"6.17647059"}
                                  stroke-width={"2"}
                                  stroke-linejoin={"round"}
                                ></line>
                                <line
                                  x1={"8.46153846"}
                                  y1={"0.411764706"}
                                  x2={"12.3076923"}
                                  y2={"6.17647059"}
                                  stroke-width={"2"}
                                  stroke-linejoin={"round"}
                                  transform={
                                    "translate(10.384615, 3.294118) scale(-1, 1) translate(-10.384615, -3.294118) "
                                  }
                                ></line>
                              </g>
                            </g>
                          </g>
                        </g>
                      </g>
                    </svg>
                  </div>
                )}
                <div>{this.getFloorPrice().toLocaleString("us")}</div>
                {this.state.currency == "MIA" && (
                  <div className={styles.MintPriceText}>MIA</div>
                )}
              </div>
              <div className={styles.MintPriceTitle}>MINT PRICE</div>
            </div>
            <div className={styles.MintPriceContainer}>
              <div className={styles.MintPriceVolumeContainer}>
                {this.nFormatter(this.getVolumeSold(), 3)}
                {this.state.currency == "MIA" && (
                  <div className={styles.MintPriceText}>MIA</div>
                )}
              </div>
              <div className={styles.MintPriceTitle}>VOLUME SOLD</div>
            </div>
          </div>
        </div>

        {/* <img
          src="https://stxnft.mypinata.cloud/ipfs/QmbN8EQh2wm6GYw9FY91gVFKuCWmD9CPTkkDa1cKE3aGah"
          alt="mempool1"
        />

        <img
          src="https://stxnft.mypinata.cloud/ipfs/QmSSZVYY8kWZk2XRn8zW1CE3quiDPk6qorYYVeSdokN9wj"
          alt="mempool2"
        /> */}

        <InfiniteScroll
          dataLength={this.getLength()}
          next={this.getBlocksNext.bind(this)}
          hasMore={this.hasMore()}
          loader={<Loading />}
          className={styles.MintPriceCardContainer}
          scrollableTarget={"page-wrapper"}
        >
          {this.renderCard()}
        </InfiniteScroll>
      </div>
    );
  }
}

export default MonkeysLabs;
